import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { httpAction } from '@/api/manage';
import moment from 'moment';
import pick from 'lodash.pick';
import { queryUserTreeList } from '@/api/api';
import IwsUpload from '@comp/upload/IwsUpload';
export default {
  name: 'AttendanceInfoModal',
  mixins: [ModalFormMixin],
  components: {
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      title: '考勤记录表单',
      tableName: 'om_attendance_info',
      form_fields: ['siteId', 'siteType', 'pushType', 'userId', 'onRemark', 'onCoordinate', 'offRemark', 'offCoordinate', 'workHour', 'photo'],
      form_fields_time: ['onDate', 'offDate'],
      validatorRules: {
        siteId: {
          rules: [{
            required: true,
            message: '请选择站点!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择打卡用户!'
          }]
        }
      },
      siteName: '',
      userTree: [] //人员信息

    };
  },
  props: ['pagePath'],
  created: function created() {
    this.siteName = sessionStorage.getItem('siteName');
  },
  watch: {
    currentSiteName: function currentSiteName(newVal, oldVal) {
      this.siteName = newVal;
    }
  },
  methods: {
    moment: moment,
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.loadTreeList();

      if (this.model.id == undefined) {
        this.model.siteId = this.siteId;
        this.model.siteName = this.siteName;
        this.model.siteType = this.siteType.toString();
      } else {
        this.siteName = this.model.siteName;
      }

      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};

        _this.form.setFieldsValue({
          onDate: _this.model.onDate ? moment(_this.model.onDate) : null
        });

        _this.form.setFieldsValue({
          offDate: _this.model.offDate ? moment(_this.model.offDate) : null
        });

        _this.$refs.iwupload.loadUploadFiles();

        that.form.setFieldsValue(timeVal);
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          formData.siteId = _this2.siteId;
          formData.onDate = that.model.onDate ? that.model.onDate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.offDate = that.model.offDate ? that.model.offDate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this2.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.userTree = res.result;
        }
      });
    }
  }
};